"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.decodePageBorder = decodePageBorder;
exports.decodePageMetadata = decodePageMetadata;
exports.decodePageInstance = decodePageInstance;
const decoded_types_1 = require("../decoded-types");
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const helpers_1 = require("../helpers");
const decode_prop_block_1 = require("./decode-prop-block");
const decode_tc31_visual_label_1 = require("./decode-tc31-visual-label");
function decodePageBorder(node, path, warnings) {
    if (!isContainer(node)) {
        warnings.push({
            type: decoded_types_1.DecodeWarningType.UnrecognizedShape,
            message: `expected container for tc:6 (PageBorder), got ${node.type}`,
            severity: sigma_engine_shared_1.BoundaryLevel.Warning,
            path,
        });
        return node;
    }
    const libId = (0, helpers_1.findPrefixedDeep)(node, '14');
    const bbox = findFirstCoordsContainer(node);
    const props = findAndDecodeLastPropBlock(node, `${path}/props`, warnings);
    return { kind: 'page-border', libId, bbox, props, raw: node };
}
function decodePageMetadata(node, path, warnings) {
    if (!isContainer(node)) {
        warnings.push({
            type: decoded_types_1.DecodeWarningType.UnrecognizedShape,
            message: `expected container for tc:14 (PageMetadata), got ${node.type}`,
            severity: sigma_engine_shared_1.BoundaryLevel.Warning,
            path,
        });
        return node;
    }
    const libId = (0, helpers_1.findPrefixedDeep)(node, '14');
    const props = findAndDecodeLastPropBlock(node, `${path}/props`, warnings);
    return { kind: 'page-metadata', libId, props, raw: node };
}
function decodePageInstance(node, path, warnings) {
    if (!isContainer(node)) {
        warnings.push({
            type: decoded_types_1.DecodeWarningType.UnrecognizedShape,
            message: `expected container for tc:55 (PageInstance), got ${node.type}`,
            severity: sigma_engine_shared_1.BoundaryLevel.Warning,
            path,
        });
        return node;
    }
    const c = node.children;
    const hash = c.length > 1 && c[1].type === 'atom' ? c[1].content.trim() : null;
    const libId = (0, helpers_1.findPrefixedDeep)(node, '14');
    const props = findAndDecodeLastPropBlock(node, `${path}/props`, warnings);
    return { kind: 'page-instance', hash, libId, props, raw: node };
}
function isContainer(node) {
    return node.type === 'container' || node.type === 'econtainer';
}
function findFirstCoordsContainer(node) {
    for (const child of node.children) {
        const bbox = (0, decode_tc31_visual_label_1.readCoordsContainer)(child);
        if (bbox !== null) {
            return bbox;
        }
    }
    return null;
}
function findAndDecodeLastPropBlock(node, path, warnings) {
    for (let i = node.children.length - 1; i >= 0; i--) {
        const child = node.children[i];
        const block = (0, decode_prop_block_1.decodePropBlock)(child, path, []);
        if (block !== null) {
            return (0, decode_prop_block_1.decodePropBlock)(child, path, warnings);
        }
    }
    return null;
}
//# sourceMappingURL=decode-tc6-tc14-tc55.js.map